import Tooltip from 'tooltip.js';

const INITIALIZED_CLASS = 'js-tooltip_initialized';

export default function() {
	$('.js-tooltip').each(function() {
		const $item = $(this);

		initTooltip($item);
	});

	window.ObserverUtil.observe('js-tooltip', $item => initTooltip($item));
}

const initTooltip = ($item) => {
	if ($item.hasClass(INITIALIZED_CLASS)) {
		return;
	}

	let container = $item.data('parent-container') ? $item.get(0).parentNode : document.querySelector('body');

	const tooltip = new Tooltip($item, {
		html: true,
		title: $item.hasClass('js-tooltip_success') ? $item.data('titleSuccess') : $item.data('title'),
		trigger: $item.data('trigger') || 'hover focus',
		closeOnClickOutside: $item.data('trigger') && $item.data('trigger').includes('click'),
		placement: $item.data('placement'),
		offset: $item.data('offset'),
		container: container,
		template: `<div class="tooltip ${$item.data('tooltip-modifier') ? $item.data('tooltip-modifier') : ''}"
											role="tooltip">
											<div class="tooltip-arrow"></div>
											<div class="tooltip-inner"></div>
								 </div>`
	});

	$item.addClass(INITIALIZED_CLASS);
};
